import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { Router, ActivatedRoute } from '@angular/router';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { Auth } from 'src/app/models/auth';
import { CartaoService } from 'src/app/services/cartao.service';
import { ContratoService } from 'src/app/services/contrato.service';
import { ApiError } from 'src/app/shared/enums/api-error.enum';

import { CartaoCadastro } from 'src/app/models/cartao-cadastro';
import { CartaoPeriodoPadrao } from 'src/app/shared/enums/cartao-periodo-padrao.enum';
import { FiltroColaboradorService } from 'src/app/services/filtro-colaborador.service';
import { NewAlertService } from 'src/app/shared/components/new-alert/new-alert.service';
import { ColaboradorService } from 'src/app/services/colaborador.service';
import { BeneficioColaborador, BeneficioGrupo } from 'src/app/models/beneficio-colaborador';

@Component({
    selector: 'app-colaborador-beneficios',
    templateUrl: './colaborador-beneficios.component.html',
    styleUrls: ['./colaborador-beneficios.component.css']
})
export class ColaboradorBeneficiosComponent implements OnInit, OnDestroy {
    public erroValor = false;


    constructor(
        private router: Router,
        private route: ActivatedRoute,
        private authenticationService: AuthenticationService,
        private alertService: NewAlertService,
        private cartaoService: CartaoService,
        private contraotoService: ContratoService,
        private filterService: FiltroColaboradorService,
        private colaboradorService: ColaboradorService) {
    }

    private colaboradorId: number;
    private urlReturn = null;
    private routeSubscription: Subscription;
    private routeSubscriptionReturn: Subscription;
    private currentUser: Auth;
    public temCartao = false;

    public persistFilter = false;

    public cartoes: CartaoCadastro[] = [];
    public CartaoPeriodoPadrao: CartaoPeriodoPadrao;

    public beneficios: BeneficioColaborador[] = [];
    public beneficioGrupo: BeneficioGrupo[] = [];

    ngOnDestroy() {
        if (!this.persistFilter) {
            this.filterService.clear();
        }
    }

    ngOnInit() {
        this.temCartao = false;

        this.routeSubscription = this.route.paramMap.subscribe(params => {
            this.colaboradorId = +params.get('colaboradorId');
        });
        this.routeSubscriptionReturn = this.route.queryParamMap.subscribe(params => {
            if (params != null) {
                this.urlReturn = params.get('urlReturn');
            }
        });

        this.currentUser = this.authenticationService.currentUserValue;

        this.colaboradorService.getBeneficiosFromColaborador(this.currentUser.token.assignorGuid, this.colaboradorId).subscribe(
            response => {
                if (response.status === ApiError.Sucesso) {
                    this.beneficioGrupo = response.result;
                } else {
                    this.alertService.error(response.message);
                }
            },
            error => {
                this.alertService.error('Erro ao buscar incentivos');
            }
        );

        /* this.contraotoService.getAll(this.currentUser.token.assignorGuid).subscribe(
            response => {
                if (response.status === ApiError.Sucesso) {
                    if (response.result) {
                        for (const s of response.result) {
                            this.cartaoService.getValid(this.colaboradorId, s.cedenteContratoId, this.currentUser.token.assignorGuid).subscribe(
                                responseCartao => {
                                    if (responseCartao.status === ApiError.Sucesso) {
                                        const cartaoExistente = new CartaoCadastro(responseCartao.result.valorPadrao, responseCartao.result.cartaoPeriodoPadraoId);
                                        cartaoExistente.cartaoId = responseCartao.result.cartaoId;
                                        cartaoExistente.produtoGuid = s.produtoElegibilidade.produto.produtoGuid.toLowerCase();
                                        cartaoExistente.descricaoProduto = s.produtoElegibilidade.produto.descricao;
                                        cartaoExistente.cedenteContratoId = s.cedenteContratoId;
                                        cartaoExistente.ativo = true;
                                        if (!cartaoExistente.valorPadrao) {
                                            cartaoExistente.valorPadrao = s.valorPadrao;
                                        }
                                        this.cartoes.push(cartaoExistente);

                                        this.temCartao = true;
                                    } else {
                                        const cartaoNovo = new CartaoCadastro(0, CartaoPeriodoPadrao.Mensal);
                                        cartaoNovo.cartaoId = 0;
                                        cartaoNovo.produtoGuid = s.produtoElegibilidade.produto.produtoGuid.toLowerCase();
                                        cartaoNovo.descricaoProduto = s.produtoElegibilidade.produto.descricao;
                                        cartaoNovo.cedenteContratoId = s.cedenteContratoId;
                                        cartaoNovo.ativo = false;
                                        cartaoNovo.valorPadrao = s.valorPadrao;
                                        this.cartoes.push(cartaoNovo);
                                    }
                                    this.cartoes = this.cartoes.sort((a, b) => a.descricaoProduto.localeCompare(b.descricaoProduto));

                                }
                            );
                        }
                    }
                } else {
                    this.alertService.error('Ocorreu um erro ao carregar os incentivos');
                }
            }
        ); */
    }

    previous() {
        this.persistFilter = true;
        this.router.navigate(['list'], { relativeTo: this.route.parent });
    }

}
